import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
export class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // Cart uses absolute max, not max minus cart quantity
  }

  /**
   * A cart line's input is server-disabled when the line can't be changed — sold out,
   * or locked by the cart (SM-776). Mirror that onto both buttons. The parent's
   * connect-time `serverDisabled*` snapshot can't do it: this element survives the
   * morph that marks a line sold out, so it would re-enable the buttons on that line.
   */
  updateButtonStates() {
    const { minusButton, plusButton, quantityInput } = this.refs;

    this.serverDisabledMinus = quantityInput.disabled;
    this.serverDisabledPlus = quantityInput.disabled;

    if (quantityInput.disabled) {
      minusButton.disabled = true;
      plusButton.disabled = true;
      return;
    }

    super.updateButtonStates();
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
